import React, { useEffect, useState } from "react";
import "../Styles/signUp.css";
import logo from "../asset/Image/greyLogo.png";
import imgs from "../asset/Image/bImg.png";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import api from "../util/axios";

type Country = {
  name: string;
  currency: string;
  capital: string;
  states: State[];
  phone_code: string;
}

type State = {
  name: string;
  cities: City[];
}

type City = {
  name: string;
}

type Category = {
  description: string
  id: string
  name: string
}

const Signup = () => {
  window.localStorage.clear();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordCVisible, setPasswordCVisible] = useState(false);
  const [getCountries, setGetCountries] = useState<Country[]>([])
  const [availableStates, setAvailableStates] = useState<State[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);

  const [sign, setSign] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    businessName: "",
    businessCategory: "",
    password: "",
    confirmPassword: "",
    address: "",
    city: "",
    state: "",
    country: "",
  });

  const getCountry = () => {
    axios.get('https://api.oneflaretech.com/api/settings/country')
      .then((res) => {
        setGetCountries(res.data.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const getCategories = () => {
    api.get('/business/adminsettings')
      .then((res) => {
        setCategories(res.data.data[0].category)
      })
      .catch((err) => {
        console.log(err)
      })
  }


  useEffect(() => {
    getCountry();
  }, []);

  useEffect(() => {
    getCategories();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (name === "country") {
      const selectedCountry = getCountries.find(country => country.name === value);
      setAvailableStates(selectedCountry ? selectedCountry.states : [])
      setSign({ ...sign, country: value, state: "", city: "" });
    } else if (name === "state") {
      setSign({ ...sign, state: value, city: "" });
    } else {
      setSign({ ...sign, [name]: value });
    }
  };

  const validatePassword = (password: string) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])(?=.*[a-zA-Z]).{8,}$/;
    return regex.test(password);
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevVisible) => !prevVisible);
  };
  const togglePasswordCVisibility = () => {
    setPasswordCVisible((prevVisible) => !prevVisible);
  };

  const handleSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();

    if (!validatePassword(sign.password)) {
      setValidationMessage(
        "Password must contain at least 8 characters, including uppercase, lowercase, number, and special character."
      );
      setLoading(false);
      return;
    }

    if (sign.password !== sign.confirmPassword) {
      setValidationMessage("Passwords do not match.");
      setLoading(false);
      return;
    }

    api
      .post("/auth/signup/business", {
        firstName: sign.firstName,
        lastName: sign.lastName,
        email: sign.email,
        phone: sign.phone,
        businessName: sign.businessName,
        businessCategory: sign.businessCategory,
        password: sign.password,
        address: sign.address,
        city: sign.city,
        state: sign.state,
        country: sign.country,
      })

      .then((res) => {
        toast.success("Account created successfully! Please verify your email.");
        console.log("res,", res.data)
        setLoading(false);
        setTimeout(() => {
          navigate("/verify-email", { state: { email: sign.email } });
        }, 3000);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  return (
    <div className="sign h-screen">
      <ToastContainer />
      <div className="signLeft">
        <img src={logo} alt="" />

        <div className="createAcc">
          <h1>Create Account</h1>
          <p>Get access to premium features now</p>

          <form onSubmit={handleSubmit} className="creatActForm">
            <div>
              <div className="input">
                <label
                  htmlFor="fname"
                >
                  First Name <span>*</span>
                </label>
                <input
                  id="fname"
                  required
                  type="text"
                  name="firstName"
                  value={sign.firstName}
                  onChange={handleChange}
                />
              </div>
              <div className="input">
                <label
                  htmlFor="lname"
                >
                  Last Name <span>*</span>
                </label>
                <input
                  id="lname"
                  type="text"
                  name="lastName"
                  required
                  value={sign.lastName}
                  onChange={handleChange}
                />
              </div>
              <div className="input">
                <label
                  htmlFor="email"
                >
                  Email <span>*</span>
                </label>
                <input
                  id="email"
                  type="email"
                  required
                  name="email"
                  value={sign.email}
                  onChange={handleChange}
                />
              </div>
              <div className="input">
                <label
                  htmlFor="password"
                >
                  Password <span>*</span>
                </label>
                <div className="SinputPass">
                  <input
                    id="password"
                    required
                    type={passwordVisible ? "text" : "password"}
                    placeholder="********"
                    name="password"
                    value={sign.password}
                    onChange={handleChange}
                  />
                  {passwordVisible ? (
                    <AiFillEyeInvisible onClick={togglePasswordVisibility} />
                  ) : (
                    <AiFillEye onClick={togglePasswordVisibility} />
                  )}
                </div>
              </div>
              <div className="input !-mb-4">
                <label
                  htmlFor="confirmPassword"
                >
                  Confirm Password <span>*</span>
                </label>
                <div className="SinputPass">
                  <input
                    id="confirmPassword"
                    required
                    type={passwordCVisible ? "text" : "password"}
                    placeholder="********"
                    name="confirmPassword"
                    value={sign.confirmPassword}
                    onChange={handleChange}
                  />
                  {passwordCVisible ? (
                    <AiFillEyeInvisible
                      style={{ cursor: "pointer" }}
                      onClick={togglePasswordCVisibility}
                    />
                  ) : (
                    <AiFillEye
                      style={{ cursor: "pointer" }}
                      onClick={togglePasswordCVisibility}
                    />
                  )}
                </div>
              </div>
              {validationMessage && (
                <span className="text-red-500 !m-4">{validationMessage}</span>
              )}
              <div className="input">
                <label
                  htmlFor="number"
                >
                  Phone Number <span>*</span>
                </label>
                <input
                  id="number"
                  type="tel"
                  required
                  name="phone"
                  value={sign.phone}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div>
              <div className="input">
                <label
                  htmlFor="address"
                >
                  Address <span>*</span>
                </label>
                <input
                  id="address"
                  required
                  type="text"
                  name="address"
                  value={sign.address}
                  onChange={handleChange}
                />
              </div>
              <div className="input">
                <label
                  htmlFor="businessName"
                >
                  Business Name <span>*</span>
                </label>
                <input
                  id="businessName"
                  type="text"
                  required
                  name="businessName"
                  value={sign.businessName}
                  onChange={handleChange}
                />
              </div>
              <div className="input">
                <label
                  htmlFor="business"
                >Business Category <span>*</span></label>
                <select
                  name="businessCategory"
                  id="business"
                  value={sign.businessCategory}
                  onChange={handleChange}
                  required
                >
                  <option value=""></option>
                  {categories.map((category) => (
                    <option key={category.name} value={category.name}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input">
                <label
                  htmlFor="country">
                  Country <span>*</span>
                </label>
                <select
                  id="country"
                  name="country"
                  value={sign.country}
                  onChange={handleChange}
                >
                  <option value=""></option>
                  {getCountries.map((country) => (
                    <option key={country.currency} value={country.name}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input">
                <label>
                  State <span>*</span>
                </label>
                <select
                  name="state"
                  id=""
                  value={sign.state}
                  onChange={handleChange}
                >
                  <option value=""></option>
                  {availableStates.map((state) => (
                    <option key={state.name} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input">
                <label>City</label>
                <input
                  type="text"
                  name="city"
                  required
                  value={sign.city}
                  onChange={handleChange}
                />
              </div>
            </div>
            <button
              style={{ cursor: "pointer" }}
              className="siBtn hover:bg-blue-600"
              type="submit"
            >
              {loading ? (
                <CircularProgress
                  style={{ color: "#fff", width: "25px", height: "25px" }}
                />
              ) : (
                "Sign Up"
              )}
            </button>
          </form>
        </div>
      </div>

      <div className="flex flex-col items-center">
        <p className=" text-lg">
          Already have an account? <span onClick={() => navigate(-1)} className="text-blue-500 cursor-pointer hover:text-blue-700">Sign In</span>
        </p>
        <img src={imgs} alt="" />
      </div>
    </div>
  );
};

export default Signup;
